import { useEffect, useState } from 'react';

interface IProps<T, R> {
    method: (data?: T) => Promise<R>;
    data?: T;
    isInitialRequest?: boolean;
    deps?: any[];
    onSuccess?: (data: R, requestData?: T) => void;
    onError?: (error: any) => void;
    onFinish?: () => void;
    condition?: boolean;
}

export const useApiQuery = <T, R>({
    method,
    deps = [],
    isInitialRequest: isInitial = true,
    data: requestData,
    condition = true,
    onError,
    onSuccess,
    onFinish
}: IProps<T, R>) => {
    const [isInitialRequest, setIsInitialRequest] = useState(isInitial);
    const [response, setResponse] = useState<R | undefined>(undefined);
    const [error, setError] = useState<string>();
    const [isLoading, setLoading] = useState(false);

    const handleRequest = async (requestData?: T) => {
        setLoading(true);
        setError(undefined);
        method(requestData)
            .then((result) => {
                setResponse(result);
                if (onSuccess) onSuccess(result, requestData);
            })
            .catch((error) => {
                console.log({ errorQuery: error });
                setError(error?.errorCode || '');
                if (onError) onError(error);
            })
            .finally(() => {
                setLoading(false);
                if (onFinish) onFinish();
            });
    };

    useEffect(() => {
        if (isInitialRequest) {
            if (condition) {
                handleRequest(requestData);
            }
        }

        setIsInitialRequest(true);
    }, deps);

    return {
        data: response,
        error,
        isLoading,
        handleRequest,
        handleRemoveResponse: () => {
            setResponse(undefined);
            setError(undefined);
        }
    };
};
